import { Injectable } from '@angular/core';
import { AuthenticationService } from '@core/authentication/authentication.service';
import { environment } from 'environments/environment';

export interface BlatOut {
  load(config: any): void;
  open(): void;
  close(): void;
  refresh(): void;
}

@Injectable({
  providedIn: 'root'
})
export class BlatoutService {
  private blatOut: BlatOut = window['BlatOut'];

  constructor(
    private readonly authenticationService: AuthenticationService
  ) {}

  public async load(): Promise<void> {
    const user = this.authenticationService.user;

    if (!this.blatOut || !user) {
      return;
    }


    this.blatOut.load({
      app: {
        id: environment.BLATOUT_APP_ID,
        title: 'Fieldnews - Boletim de novidades do Field Control',
      },
      user: {
        id: user.id,
        hash: user.fieldNewsEmailHash,
        email: user.email,
        name: user.name
      },
      widgets: {
        badge: {
          type: 'counter',
          selector: '#blatout-badge-counter'
        }
      }
    });
  }

  public refresh(): void {
    if (!this.blatOut) {
      return;
    }
    this.blatOut.refresh();
  }

  public open(): void {
    if (!this.blatOut) {
      return;
    }
    this.blatOut.open();
  }
}
